/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GreyfinchPay/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function GreyfinchPay({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/GreyfinchPay",
  onChange
  
}) {
let providerAccountGreyfinchPayAppEnabledValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'greyfinch_pay_app_enabled',
})
let providerAccountGreyfinchPayAppEnabledChangeData = fromData.useDataChange({ viewPath,
context: 'provider_account',
path: 'greyfinch_pay_app_enabled',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 data="provider_account.greyfinch_pay_app_enabled"
 value={providerAccountGreyfinchPayAppEnabledValueData}
 onChange={providerAccountGreyfinchPayAppEnabledChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Automatically send request for payment when autopay fails."
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}